import React from 'react';
import useStyles, { STYLES, TONE_STYLES, mergeStyles } from '../../useStyles';
import { KEY_STATUS_META } from '../../constants';
import { KeyStatus, Tone } from '../../types';

interface IBadgeProps {
	tone: Tone;
	label: string;
}

const Badge: React.FC<IBadgeProps> = ({ tone, label }) => {
	const { css } = useStyles();
	return <span className={css(mergeStyles(STYLES.badge, TONE_STYLES[tone]))}>{label}</span>;
};

export const KeyStatusBadge: React.FC<{ keyStatus: KeyStatus }> = ({ keyStatus }) => {
	const meta: { label: string; tone: Tone } = KEY_STATUS_META[keyStatus] || { label: keyStatus, tone: 'neutral' };
	return <Badge tone={meta.tone} label={meta.label} />;
};

export default Badge;
